import * as React from 'react';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import classNames from 'classnames';
import {
  Container,
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import { ProfileDefault } from '../../../../types/uncinc_profile/profile';

import './style.scss';

interface ProfileProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<ProfileDefault>;
}

const ProfilePage: React.FC<ProfileProps> = ({ entity, className }) => {
  const classes = classNames(className, 'ProfilePage');
  const profile = entity.toJS();
  const profileName = profile.field_full_name[0].value;
  const profileFirstName = profileName.split(' ')[0];
  const profileDescription = profile.field_description?.[0]?.processed;
  const profileEmail = profile.field_email_address?.[0]?.value;
  const profileFunction = profile.field_function?.[0]?.entity.name[0].value;
  const imageStyles = profile.field_media_item?.[0]?.styles;
  const telephone = profile.field_telephone?.[0]?.value;

  const src = [
    `${imageStyles?.ratio_1_1_sm || ''}`,
  ];

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <Container small>
        <div className="ProfilePage__hero">
          <div className="ProfilePage__hero__details">
            <div className="ProfilePage__image">
              <Image
                src={src}
                alt={profileName}
              />
            </div>
            <div className="ProfilePage__description">
              <h2 itemProp="name">{profileName}</h2>
              <p>{profileFunction}</p>
              <div className="ProfilePage__links">
                <CoreLink to={`tel:${telephone}`}><span className="icon icon-phone icon-variant-2" /> {telephone}</CoreLink>
                <CoreLink to={`mailto:${profileEmail}`}><span className="icon icon-mail icon-variant-2" /> Mail {profileFirstName}</CoreLink>
              </div>
            </div>
          </div>
          {profileDescription ? (
            <WysiwygField
              property="schema:text"
              html={profileDescription}
            />
          ) : null}
        </div>
      </Container>
    </article>
  );
};

export default ProfilePage;
